import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
// redux
import { logout } from 'redux/auth/operations';
import { selectUsersListNew } from 'redux/users/usersSelectors';
// hooks
import { useAuth } from 'hooks';
// scss
import './AuthBox.scss';

const AuthBox = ({ isSuperAdmin }) => {
  const [showEsc, setShowEsc] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const usersList = useSelector(selectUsersListNew);
  const { user } = useAuth();
  const newUsersNumber = usersList?.length;
  const userName = user?.name || "U";
  const userNameChar1 = userName?.slice(0, 1);

  function onCabinetBtnClick() {
    navigate(`/users${newUsersNumber > 0 ? "/new" : ""}`, {state: {from: location}});
  }
  function onLogout() {
    dispatch(logout());
  }

  return (
    <div className="authbox">
      <button className="authbox__btn--cabinet" type="button" onClick={onCabinetBtnClick} disabled={!isSuperAdmin} title={userName}>
        {userNameChar1}
        {newUsersNumber > 0 && <span>{newUsersNumber}</span>}
      </button>
      <button className={`authbox__btn--show-esc ${showEsc ? "active" : ""}`} type="button" onClick={() => setShowEsc(!showEsc)}>
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="8" viewBox="0 0 13 8" fill="none">
          <path d="M1.44714 1.60852L6.55392 6.49941L11.4448 1.39263" stroke="#B79A5D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>
      <button className={`authbox__btn--esc ${showEsc ? "" : "isHidden"}`} type="button" onClick={onLogout}>
        Вихід
        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none" >
          <path d="M3.66667 5H9M9 5L7.33333 3.88889M9 5L7.33333 6.1111M9 2.55556V1.5C9 1.22386 8.70153 1 8.33333 1H1.66667C1.29848 1 1 1.22386 1 1.5V8.5C1 8.77615 1.29848 9 1.66667 9H8.33333C8.70153 9 9 8.77615 9 8.5V7.44445" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>
    </div>
  );
};

export default AuthBox;
